import $ from 'jquery';
import whatInput from 'what-input';
export default class A11yUtils {
  constructor() {}

  static get keyboard() {
    return {
      // delete key on mac
      back: 8,
      tab: 9,
      enter: 13,
      // shiftKey = true
      shift: 16,
      // ctrlKey = true
      ctrl: 17,
      // (a.k.a. option on Mac) altKey = true
      alt: 18,
      esc: 27,
      space: 32,
      // fn + up on mac
      pageUp: 33,
      // fn + down on mac
      pageDown: 34,
      // fn + right on mac
      end: 35,
      // fn + left on mac
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      // fn + delete on mac
      del: 46,
      // metaKey = true (mac and sun machines)
      command: 91,
    };
  }

  static get ARIA() {
    return {
      label: 'aria-label',
      expanded: 'aria-expanded',
      hidden: 'aria-hidden',
      controls: 'aria-controls',
      live: 'aria-live'
    }
  };

  static get FOCUSABLES() {
    return 'a[href], area[href], input:not([disabled]), select:not([disabled]), ' +
      'textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
  }

  static get FOCUSABLES_VISIBLE() {
    return 'a[href]:visible, area[href]:visible, input:not([disabled]):visible, ' +
      'select:not([disabled]):visible, textarea:not([disabled]):visible, ' +
      'button:not([disabled]):visible, iframe:visible, object:visible, embed:visible, ' +
      '*[tabindex]:visible, *[contenteditable]:visible';
  }

  static getFocusablesOnpage() {
    return $('body').find(this.FOCUSABLES_VISIBLE);
  }

  static senseClickOutside($evtTarget, $container) {
    if (($evtTarget).closest($container).length === 0) {
      // click target is outside
      return true;
    }
    return false;
  }

  static announcements($ariaContainer, textToRead) {
    $ariaContainer.text(textToRead);
    const timeOutMs = 5000;
    setTimeout(function () {
      $ariaContainer.text('');
    }, timeOutMs);
  }

  static isHidden(el) {
    const style = window.getComputedStyle(el);
    return ((style.display === 'none') || (style.visibility === 'hidden'));
  }

  static targetBlankLabelling($container) {
    $('a[target="_blank"]', $container).each((i, e) => {
      const $elt = $(e);
      const title = $elt.attr(this.ARIA.label);
      const txt = typeof title != 'undefined' ? title : $elt.text();
      $elt.attr(this.ARIA.label, txt + ' ' + this.newWindowLabel());
    });
  }

  static inputIsKeyboard(){
    return whatInput.ask() === 'keyboard'
  }

  static newWindowLabel() {
    const lang = $('html').attr('lang');
    let newWindow;
    switch (lang) {
      case 'fr':
        newWindow = '(nouvelle fenêtre)';
        break;
      case 'de':
        newWindow = '(neues Fenster)';
        break;
      case 'zh-hans':
        newWindow = '(新窗户)';
        break;
      case 'zh-hant':
        newWindow = '(新窗戶)';
        break;
      case 'ja':
        newWindow = '(新しい窓)';
        break;
      case 'ru':
        newWindow = '(новое окно)';
        break;
      default:
        newWindow = '(new window)';
        break;
    }
    return newWindow;
  }

}
